import { render } from "./DemoModal.vue?vue&type=template&id=374b06b5&scoped=true&ts=true"
import script from "./DemoModal.vue?vue&type=script&lang=ts"
export * from "./DemoModal.vue?vue&type=script&lang=ts"

import "./DemoModal.vue?vue&type=style&index=0&id=374b06b5&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-374b06b5"]])

export default __exports__